module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "sigil_not_in_toc"
  }, [_vm._v("Copyright")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Diversion Books"), _c('br'), _vm._v("\n  A Division of Diversion Publishing Corp."), _c('br'), _vm._v("\n  443 Park Avenue South, Suite 1008"), _c('br'), _vm._v("\n  New York, NY 10016"), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://www.DiversionBooks.com",
      "target": "_blank"
    }
  }, [_vm._v("www.DiversionBooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Copyright © 2000 by Candace Robb"), _c('br'), _vm._v("\n  All rights reserved, including the right to reproduce this book or portions thereof in any form whatsoever.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("This is a work of fiction. Names, characters, places and incidents either are the product of the author’s imagination or are used fictitiously. Any resemblance to actual persons, living or dead, events or locales is entirely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("For more information, email "), _c('a', {
    attrs: {
      "href": "mailto:info@diversionbooks.com"
    }
  }, [_vm._v("info@diversionbooks.com")])]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("First Diversion Books edition August 2015"), _c('br'), _vm._v("\n  ISBN: 978-1-68230-005-3")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "sigil_toc_id_1",
      "title": "Dedication"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "sectiontop",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("In memory of Nigel Tranter, who invited me to tea and inspired me to walk with my muse.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "page-break-after": "always"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "none"
    }
  })]), _vm._v(" "), _c('h2', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("Acknowledgements")]), _vm._v(" "), _c('p', {
    staticClass: "sectiontop"
  }, [_vm._v("Elizabeth Ewan has been so generous with her expertise and time, enthusiastically helping me create and recreate the world of Margaret Kerr. No question regarding Scottish history and culture was too quibbling. Her suggestions have made it all the richer. My friend Joyce Gibb has been a patient, calming and encouraging sounding board and reader, working miracles with tight deadlines. Kate Elton did a wonderfully provocative final emotive edit.")]), _vm._v(" "), _c('p', [_vm._v("Claudia Noyes advised me on vertical looms and card weaving, even giving me hands-on experience with the latter—it is much more difficult than it looks. Alan Young provided me with a balanced bibliography for the Wars of Independence. Brian Moffat spent a cold, blustery Easter Monday atop Soutra Hill sharing his knowledge of the great medieval hospital with my husband and me. And Charles Robb has made good use of our explorations to provide the maps. As ever, I’m grateful to my colleagues and friends on Chaucernet and Medfem and all who participate in the annual International Congress of Medieval Studies at Kalamazoo.")]), _vm._v(" "), _c('p', [_vm._v("And my especial thanks to Lynne Drew, Sara Ann Freed, Evan Marshall and Patrick Walsh for their wisdom and encouragement, and for believing in Margaret when she was just an idea.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c040cb9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/TB_copy.vue
// module id = 69
// module chunks = 0